export const APPLE = 'apple';
export const GOOGLE = 'google';
export const BRAINTREE = 'braintree';
export const NEWEB = 'neweb';
export const NEWEB_MMK = 'neweb_mmk';
export const NEWEB_ATM = 'neweb_atm';
export const PAYNOW = 'PAYNOW';
export const COD = 'COD';
export const PAY_BY_2C2P = '2c2p';
export const LINE_PAY = 'line_pay';

// TODO: no sure if we have a chance to make bank transfer payment method become a official payment method
// it should control via our backend instead of website.
export const TH_BANK_TRANSFER = 'TH_BANK_TRANSFER';
export const BANK_TRANSFER = 'bankTransfer';

export const NEWEB_FRONTEND_TO_BACKEND = {
  [NEWEB_ATM]: 'atm',
  [NEWEB_MMK]: 'mmk',
};

export const UPPER_LIMIT = {
  [NEWEB_MMK]: 20000,
};

export const ALLOW_DISCOUNT_CODE_PAYMENT_LIST = [
  BRAINTREE,
  NEWEB_MMK,
  NEWEB_ATM,
  LINE_PAY,
];



// WEBPACK FOOTER //
// ./app/constants/paymentTypes.js